import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { styles } from '../style';
import { ComputersCanvas } from './canvas';

const Hero = () => {
  const navigate = useNavigate();

  const handleScrollToAbout = () => {
    navigate('/about', { state: { triggerAnimation: true } }); // Make sure /about route exists
  };

  return (
    <section className="relative w-full h-screen mx-auto">
      <div className={`${styles.paddingX} absolute inset-0 top-[120px] max-w-7x1 mx-auto flex flex-role items-start gap-5 mt-10`}>
        <div className="flex flex-col justify-center items-center mt-5">
          <div className='w-5 h-5 rounded-full bg-[#915eff]' />
          <div className="w-1 sm:h-80 h-40 violet-gradient"></div>
        </div>
        <div>
          <h1 className={`${styles.heroHeadText} text-white `}>Hi, I'm <span className='text-[#915eff]'>Daniel</span></h1>
          <p className={`${styles.heroSubText} mt-2 text-white-100`}>
            I develop Full stack, user interfaces, <br className='sm:block hidden' /> Web3 web and Server side application
          </p>
        </div>
      </div>
      <ComputersCanvas />
      <div className="absolute xs:bottom-19 bottom-2 w-full flex justify-center items-center">
        <a href="#about" onClick={handleScrollToAbout}>
          <div className="w-[35px] h-[65px] rounded-[50px] border-4 border-secondary flex justify-center items-start p-2">
            <motion.div 
              animate={{ y: [0, 24, 0] }}
              transition={{ duration: 1.5, repeat: Infinity, repeatType: 'loop' }}
              className='w-3 h-3 rounded-full bg-secondary mb-1'
            />
          </div>
        </a>
      </div>
    </section>
  );
}

export default Hero;
